import FiltrosPagosSinFactura from '../../moleculas/FiltrosPagosSinFactura/FiltrosPagosSinFactura'

function FiltrosPagosSinFacturaContainer() {
  return (
    <div className="flex flex-row justify-around m-3">
      <FiltrosPagosSinFactura/>      

  </div> 
  )
}

export default FiltrosPagosSinFacturaContainer